import { useEffect, useState } from 'react';

const useDevice = (size = 731) => {
    const condition = () => window.innerWidth < size;

    const [isMobile, setIsMobile] = useState(condition());

    const checkForDevice = () => setIsMobile(condition());

    useEffect(() => {
        checkForDevice();

        window.addEventListener('resize', checkForDevice);

        return () => {
            window.removeEventListener('resize', checkForDevice);
        };
    }, []);

    return {
        isMobile,
        isDesktop: !isMobile,
    };
};

export default useDevice;
